var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSoundOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-sound-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.197,
    height: 22.262,
    viewBox: "0 0 30.197 22.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fffbf3;\n      }\n\n      .cls-2 {\n        opacity: 0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M37.463,25.27a.774.774,0,0,0-.8.045l-7.806,5.309H25.2a3.393,3.393,0,0,0-3.39,3.39v4.6A3.393,3.393,0,0,0,25.2,42h3.659l7.806,5.309a.766.766,0,0,0,.435.135.791.791,0,0,0,.363-.09.774.774,0,0,0,.413-.686V25.956A.765.765,0,0,0,37.463,25.27ZM36.324,45.2l-6.793-4.618a.766.766,0,0,0-.435-.135H25.2a1.836,1.836,0,0,1-1.834-1.834v-4.6A1.836,1.836,0,0,1,25.2,32.174h3.9a.745.745,0,0,0,.435-.135l6.793-4.618Z",
    transform: "translate(-21.81 -25.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-2",
    d: "M70.261,35.635a9.968,9.968,0,0,0-3.829-4.524A.776.776,0,0,0,65.6,32.42a8.409,8.409,0,0,1,0,14.187.776.776,0,0,0,.417,1.43.788.788,0,0,0,.417-.121,10.056,10.056,0,0,0,1.695-1.359,9.965,9.965,0,0,0,2.134-10.922Z",
    transform: "translate(-45.767 -28.385)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-2",
    d: "M65.137,43.11A6.628,6.628,0,0,0,62,37.631a.776.776,0,0,0-.834,1.309,4.806,4.806,0,0,1,0,8.34.776.776,0,0,0,.417,1.43A.788.788,0,0,0,62,48.589,6.628,6.628,0,0,0,65.137,43.11Z",
    transform: "translate(-43.323 -31.981)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18738",
    "data-name": "Group 18738",
    transform: "translate(17.327 4.696)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18436",
    "data-name": "Rectangle 18436",
    className: "cls-1",
    width: 2.022,
    height: 16.179,
    rx: 1.011,
    transform: "translate(11.44 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18437",
    "data-name": "Rectangle 18437",
    className: "cls-1",
    width: 2.022,
    height: 16.179,
    rx: 1.011,
    transform: "translate(12.87 11.44) rotate(135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOff);
export default __webpack_public_path__ + "static/media/icon-sound-off.d4df0b1294cddad91f412b98bbc18052.svg";
export { ForwardRef as ReactComponent };